import { searchBusinessTerm } from '@wix/ambassador-funnel-taxonomy-v1-business-term/http'
import type { BusinessTerm } from '@wix/ambassador-funnel-taxonomy-v1-business-term/types'
import { getBusinessTermById } from '@wix/ambassador-funnel-taxonomy-v2-business-term/http'
import { CancelTokenSource, IHttpClient } from '@wix/http-client'

import { withMonitoring } from '../../../../monitoring/withMonitoring'

export class BusinessTermService {
  constructor(private readonly httpClient: IHttpClient) {}

  async search({
    query,
    limit,
    language,
    cancelToken,
  }: {
    query: string
    limit: number
    language: string
    cancelToken?: CancelTokenSource['token']
  }): Promise<BusinessTerm[]> {
    // API has limitation of 100 characters
    if (query.length >= 100) {
      return []
    }
    const request = searchBusinessTerm({ q: query, limit, locale: language })
    ;(request as any).cancelToken = cancelToken
    const res = await withMonitoring(() => this.httpClient.request(request), 'Category-loadCategories')
    return res.data.results || []
  }

  async getBusinessSegmentIdByTermId(
    businessTermId: string,
    cancelToken?: CancelTokenSource['token'],
  ): Promise<string | undefined> {
    const request = getBusinessTermById({ businessTermId })
    ;(request as any).cancelToken = cancelToken
    let businessSegmentId
    try {
      const res = await withMonitoring(() => this.httpClient.request(request), 'Category-loadBusinessSegment')
      businessSegmentId = res.data.businessTerm?.businessSegmentId || undefined
    } catch (e) {
      console.error('Failed to get business segment id', e)
    }
    return businessSegmentId
  }
}
